import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import Button from '../../../components/common/Button';
import { showLoader, hideLoader } from '../../store/common/slice';
import { changeTab } from '../../store/manager/slice';
import { useAccessToken } from '../../common/hooks/useAccessToken';
import CommentsModal from '../comments/CommentsModal';
import { StyledAptCard } from './ActiveCampaign.styled';

export const InnerCardWrapper = ({ header, value }) => {
    return (
        <div className='apartment-info-inner-wrapper'>
            <div className='header'>{header}</div>
            <div className='value'>{value}</div>
        </div>
    )
};

const AptCardWithCampaign = ({ apt, renter, phone, email, campaignType, campaignStep, nextStepIn, totalSteps, nextStepType, buildingID }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const ltr = useSelector(state => state.common.ltrEnabled);
    const history = useHistory();
    const client = useAccessToken();

    const [commentsModalOpened, setCommentsModalOpened] = useState(false);

    const onPaymentStateClick = () => {
        dispatch(changeTab('monthly'));

        history.push({ 
            pathname: `/reports/apartment/${buildingID}/${apt}`, 
        });
    };

    const onAptNotesClick = () => setCommentsModalOpened(true);

    const onCampaignStop = async () => {
        dispatch(showLoader());
        // TODO: this code looks weird - no await here
        const response = client.patch(`operations/building/${buildingID}/apartment/${apt}/finished`);
        dispatch(hideLoader());
        if (response.finished === 1) {
            NotificationManager.success(t('managerAutoCampaign.activeCampaign.successfully_removed'));
            setTimeout(() => window.location.reload(), 2000);
        } else NotificationManager.error(t('buildings.something_wrong'));
    };

    const closeModal = () => setCommentsModalOpened(false);

    return (
        <StyledAptCard ltr={ltr}>
            <div className='first-row'>
                <InnerCardWrapper 
                    header={t('notifications.apartment')}
                    value={apt}
                />
                <InnerCardWrapper 
                    header={t('reports.tenantName')}
                    value={renter}
                />
                <InnerCardWrapper 
                    header={t('notifications.phone')}
                    value={phone}
                />
                <InnerCardWrapper 
                    header={t('notifications.email')}
                    value={email}
                />
            </div>
            <div className='second-row'>
                <InnerCardWrapper 
                    header={t('managerAutoCampaign.activeCampaign.labels.campaignType')}
                    value={campaignType}
                />
                <InnerCardWrapper 
                    header={t('managerAutoCampaign.activeCampaign.labels.campaignStep')}
                    value={`${campaignStep} ${t('managerAutoCampaign.activeCampaign.labels.of')} ${totalSteps}`}
                />
                <InnerCardWrapper 
                    header={t('managerAutoCampaign.activeCampaign.labels.nextStepIn')}
                    value={`${nextStepIn} ${t('managerAutoCampaign.activeCampaign.labels.days')}`}
                />
                <InnerCardWrapper 
                    header={t('managerAutoCampaign.activeCampaign.labels.nextStepType')}
                    value={nextStepType}
                />
            </div>
            <div className='buttons-wrapper'>
                <Button rounded={false} outlined onClick={onAptNotesClick}>
                    {t('managerAutoCampaign.activeCampaign.btns.aptNotes')}
                </Button>
                <Button rounded={false} outlined onClick={onPaymentStateClick}>
                    {t('payment_settings.paymentState')}
                </Button>
                <Button rounded={false} outlined onClick={onCampaignStop}>
                    {t('managerAutoCampaign.activeCampaign.btns.stopCampaign')}
                </Button>
            </div>

            <CommentsModal
                show={commentsModalOpened}
                buildingId={buildingID}
                onModalHide={closeModal}
                apartmentNum={apt}
            />
        </StyledAptCard>
    );
};

export default AptCardWithCampaign;
